export const DateFormat = "YYYY-MM-DD";

export const AgentTabs = {
  REGISTRY: "Registry",
  TOP_UP_REQUEST: "Top up Request",
};

export const BusTabs = {
  CONDUCTOR: "Conductor",
  BUS: "Registry",
  DRIVER: "Driver",
  STRUCTURE: "Structure",
};

export const AccessControlTabs = {
  ROLE: "Role",
  ROLE_PERMISSION: "Role Permissions",
};

export const DatabaseTabs = {
  TERMS_CONDITION: "Terms and Conditions",
  CANCELLATION_POLICY: "Cancellation Policy",
  AMENITIES: "Amenities",
  ACCOUNT: "Account",
  CITY: "Cities",
  ROUTE: "Route",
  ASSOCIATION_IMAGE: "Bus Association Logo & Theme",
};

export const TripTabs = {
  REPORT: "Report",
  ROUTE: "Route",
  UPDATE: "Update",
  CANCELLATION_REQUEST: "Cancellation Request",
  GENERATE: "Generate",
  AUTO_ASSIGN: "Auto Assign",
  ALLOWANCE: "Allowance",
};

export const TicketTabs = {
  TICKETS: "Tickets",
  CANCELLATION_REQUEST: "Cancellation Request",
  TICKET_CANCELLATION: "Ticket Cancellation",
};

export const AuditTabs = {
  CONDUCTOR: "Conductor",
  AGENT: "Agent",
  RECONCILIATION: "Reconciliation",
};

export const UserTabs = {
  CUSTOMER: "Customer",
  DIRECTOR: "Director",
  FINANCE: "Finance",
  BASIC: "Basic",
  OPERATION: "Operation",
  REPORTER: "Reporter",
  AUDITOR: "Financial ticket inspection & auditor",
  DIRECTOR_AUDITOR: "Auditor",
  CASHIER: "Cashier",
};

export const ReportTabs = {
  OFECHO: "Ofecho",
  WEEKLY: "General Report",
  SEMERIT: "Semerit",
  AGENT_SALES_REPORT: "Agent Sales Report",
  DAILY_TICKETS: "Daily Tickets Report",
  TRIP_SUMMARY_REPORT: "Trips Summary Report",
  SUB_ROUTE_REPORT: "Sub Route Report",
};

export const ERCATabs = {
  SALES_REPORT: "Sales Report",
  SUMMARY_REPORT: "Summary Report",
  BOOKING_BALANCE: "Booking Balance",
  Individual: "Individual Ticket Report",
  TRIP_SALES_REPORT: "Trip Sales Report",
};

export const UserStatus = {
  ACTIVE: "ACTIVE",
  BLOCKED: "BLOCKED",
} as const;

export const BusAdminRole = {
  Director: "user_director",
  Finance: "user_finance",
  Basic: "user_basic",
  Operation: "user_oprator",
  Reporter: "user_reporter",
  Auditor: "user_auditor",
  DirectorAuditor: "user_director_auditor",
  Cashier: "user_cashier",
} as const;

export const ETHIOPIAN_MONTHS = [
  "መስከረም",
  "ጥቅምት",
  "ኅዳር",
  "ታኅሣሥ",
  "ጥር",
  "የካቲት",
  "መጋቢት",
  "ሚያዝያ",
  "ግንቦት",
  "ሰኔ",
  "ሐምሌ",
  "ነሐሴ",
  "ጳጉሜ",
];

export enum TripStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum RouteStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export const BUS_ASSOCIATION_INFO = {
  name_english: "Public Bus",
  name_amharic: "ፐብሊክ ባስ",
  print_name_english: "Public Service Transport Service",
  print_name_amharic: "ፐብሊክ ሰርቪስ ትራንስፖርት አገልግሎት",
};

export const telegram_bot_url = "https://t.me/PublicBusBot";
